module.exports = __webpack_public_path__ + "static/media/ads_4x3_11.ae4893a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ads_4x3_11.svg
// module id = 261
// module chunks = 0